(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class CollectionToolbar extends HTMLElement {
    connectedCallback() {
      const sortSelect = this.querySelector('[data-sort-select]');
      sortSelect?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });

      const toggle = this.querySelector('[data-filter-toggle]');
      const panel = document.querySelector('[data-filter-panel]');
      const overlay = document.querySelector('.collection__filters-overlay');
      const closers = document.querySelectorAll('[data-filter-close]');

      toggle?.addEventListener('click', () => {
        panel?.classList.add('is-open');
        overlay?.classList.add('is-open');
      });

      closers.forEach((closer) => {
        closer.addEventListener('click', () => {
          panel?.classList.remove('is-open');
          overlay?.classList.remove('is-open');
        });
      });
    }
  }

  if (!customElements.get('collection-toolbar')) {
    customElements.define('collection-toolbar', CollectionToolbar);
  }
  } catch(e) { console.error(e); }
})();

})();
